module.exports = __webpack_public_path__ + "static/media/BT.efa4e676.svg";